import { styled, Box, Button, createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const MainCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : COLORS.WHITE,
  padding: 1,
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  border: 'none',
  // backgroundImage: 'linear-gradient(to bottom, #0e1319, #0e1319), linear-gradient(253deg, #d51bff, #00d4ff)',
}));

export const ButtonCont = styled(Box)(() => ({
  marginTop: 10,
  display: 'flex',
  justifyContent: 'space-between',
  width: 380,
}));

export const SelectButton = styled(Button)(() => ({
  flex: 1,
  // backgroundColor: '#3e8bff',
  height: 44,
  color: COLORS.WHITE,
}));

export const CancelButton = styled(Button)(() => ({
  height: 44,
  flex: 1,
  border: 'solid 1px #3e8bff',
  marginLeft: 20,
  backgroundColor: 'transparent',
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK) + '!important', // Change this to your desired color,
      },
    },
    popoverBox: {
      boxShadow: 'none',
      border: '3px solid',
      borderColor: COLORS.PRIMARY,
      borderRadius: 8,
    },
  }),
);
